import { DataProvider, Pagination } from '@refinedev/core';
import { AxiosInstance } from 'axios';
import { default as simpleRestDataProvider } from '@refinedev/simple-rest';
import { isPaginated } from '@aphp-ema/common/shared/paging';
import { adaptFilters } from './adaptFilters';

export const dataProvider = ({
  baseUrl,
  axiosInstance,
}: {
  baseUrl: string;
  axiosInstance: AxiosInstance;
}): DataProvider => {
  const baseDataProvider = simpleRestDataProvider(baseUrl, axiosInstance);

  const dataProvider = {
    ...baseDataProvider,
    getList: async ({ resource, pagination, filters }) => {
      const url = `${baseUrl}/${resource}`;

      const offset = toOffset(pagination);
      const limit = pagination?.pageSize;
      const { data } = await axiosInstance.get(url, {
        params: { offset, limit, ...adaptFilters(filters) },
      });

      if (isPaginated(data)) {
        return {
          data: data.data,
          total: data.total,
        };
      } else {
        return {
          data,
          total: data.length,
        };
      }
    },
  } satisfies DataProvider;

  return dataProvider;
};

function toOffset(pagination?: Pagination) {
  return pagination?.current !== undefined && pagination.pageSize !== undefined
    ? (pagination.current - 1) * pagination.pageSize
    : undefined;
}
